export default __webpack_public_path__ + "static/media/steve-harvey-U4wcrDteZ2Y-unsplash.b9300cda.jpg";